<template>
  <div class="create-user">
    <Header />
    <Main>
      <h3 class="text-center">Создание пользователя</h3>
      <b-overlay :show="loading">
        <user-form v-model="userData" class="create-user__form" />
      </b-overlay>
    </Main>
    <bottom-overlay v-if="edited">
      <b-button
        @click="createUser"
        block
        squared
        variant="success"
        class="create-person__create-button"
        :disabled="loading"
      >
        Создать пользователя
      </b-button>
    </bottom-overlay>
  </div>
</template>
<script>
import Main from "@/components/Layout/Main";
import UserForm from "@/components/Forms/User/UserForm";
import BottomOverlay from "@/components/BottomOverlay";
import UserModel from "@/components/Forms/User/models/userModel";
import pageTitleMixin from "@/mixins/pageTitleMixin";
export default {
  components: { BottomOverlay, UserForm, Main },
  mixins: [pageTitleMixin],
  data() {
    return {
      userData: new UserModel(),
      loading: false
    };
  },
  computed: {
    edited: ({ userData }) =>
      JSON.stringify(userData) !== JSON.stringify(new UserModel())
  },
  methods: {
    createUser() {
      this.loading = true;
      this.$store
        .dispatch("users/createUser", this.userData)
        .then(() => this.$router.push(`/users`))
        .catch(() => (this.loading = false));
    }
  }
};
</script>

<style lang="scss">
.create-user {
  &__form {
    margin: 0 5px;
  }
}
</style>
